// spot-status.js — Zustand eines Platzes für die Abzeichen in Entdecken (Liste und Karte, 2026-10-26):
//   'full'   heute/zurzeit als voll gemeldet (spots.full_until in der Zukunft, v500)
//   'open'   laut Saisonangabe jetzt geöffnet oder ganzjährig
//   'off'    laut Saisonangabe außerhalb der Saison
//   'closed' dauerhaft geschlossen (spots.closed_at, v502)
//   null     unbekannt — keine Saisonangabe oder nicht lesbar (rund 90 % der Plätze): KEIN Zeichen, ein falscher Haken wäre
//            schlimmer als keiner.
import { seasonInfo } from './season-info.js';

export const STATUS = {
  open: { icon: 'check', key: 'app2.ex.st_open' },
  off: { icon: 'close', key: 'app2.ex.st_off' },
  full: { icon: 'event_busy', key: 'app2.ex.st_full' },
  closed: { icon: 'block', key: 'app2.ex.st_closed' },
};

export function spotStatus(s, now = new Date()) {
  if (!s) return null;
  if (s.closed_at) return 'closed';
  if (s.full_until && Date.parse(s.full_until) > now.getTime()) return 'full';
  const st = seasonInfo(s.season, now).state;
  if (st === 'offen' || st === 'ganzjaehrig') return 'open';
  if (st === 'geschlossen') return 'off';
  return null;
}
